export const PROFILE_OPTIONS = [
	{ label: 'Student', desc: '14 to 17 years old', route: '/login' },
	{ label: 'Parent', desc: 'Interested for my child', route: '/parents' },
	{ label: 'Counselor', desc: 'College counselor or advisor', route: '/counselors' },
] as const

export const PROFILE_ROUTE_MAP: Record<string, string> = {
	Student: '/login',
	Parent: '/parents',
	Counselor: '/counselors',
}
